import React, { useState } from "react";
import "./Footer.css";
import CurveImg from "../../assets/Footer/Rectangle 46523.jpg";
import logo from "../../assets/navbar/Group 1000008451 (1) 1.svg";
import { FaFacebook, FaLinkedin, FaPhoneAlt, FaYoutube } from "react-icons/fa";
import { FaSquareInstagram } from "react-icons/fa6";
import whtsImg from "../../assets/Footer/image 74709.svg";
import { useNavigate } from "react-router-dom";
import { IoMdMail } from "react-icons/io";
const Footer = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    industries: "",
    phone: "",
    message: "",
  });
  const navigate = useNavigate()

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const scriptURL =
      "https://script.google.com/macros/s/AKfycbwN9YxX6MdzDLg0C-q_mFjZskxftcKs99Qx_f27F20EdMRc1SxKHwo9gXRquZOgRTtw/exec";

    try {
      const todayDate = new Date()
      const formPayload = new FormData();
      for (let key in formData) {
        formPayload.append(key, formData[key]);
      }
      formPayload.append("Date", todayDate)
      const response = await fetch(scriptURL, {
        method: "POST",
        body: formPayload, // No 'Content-Type' header for FormData
      });

      if (response.ok) {
        alert("Form submitted successfully!");
        setFormData({
          name: "",
          email: "",
          industries: "",
          phone: "",
          message: "",
        });
      } else {
        alert("Something went wrong. Please try again.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Error submitting the form. Please check your connection.");
    }
  };

  const handleWhatsappNavigate = () => {
    window.open("https://wa.me/message/7UIP4VY3P674N1", "_blank");
  };
  return (
    <>
      <div className="footer_container">
        <div className="logo_div">
          <img src={logo} alt="logo" />
        </div>
        <div class="curved_background">
          <img src={CurveImg} alt="curveImg" />
        </div>
        <div className="footer_content_wrapper">
          <div className="footer_form">
            <form onSubmit={handleSubmit} name="google-sheet">
              <div className="footer_form_wrap">
                <div className="footer_form_top">
                  <input
                    type="text"
                    name="name"
                    placeholder="Name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="footer_form_bottom">
                  <input
                    type="text"
                    name="industries"
                    placeholder="Company Name"
                    value={formData.industries}
                    onChange={handleChange}
                    required
                  />
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>
              <div className="footer_form_text">
                <textarea
                  name="message"
                  placeholder="Message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>
              <div className="footer_submit">
                <button type="submit">Submit</button>
              </div>
            </form>
          </div>

          <div className="footer_right_links">
            <div className="footer_right_header">
              <h1>Ready to Elevate Your Business?</h1>
              <p>
                Join us today and unlock the tools you need to grow smarter,
                faster, and stronger!
              </p>
            </div>
            <div className="footer_li_items">
              <div className="footer_li_items_left">
                <ul>
                  <li>Home</li>
                  <li>Features</li>
                  <li>Solutions</li>
                  <li>Pricing</li>
                </ul>
                <ul>
                  <li>Resources</li>
                  <li>Integrations</li>
                  <li>Support</li>
                </ul>
              </div>
              <div className="footer_li_items_right">
                <h1>Contact Us</h1>
                <p>
                  <span>
                    <FaPhoneAlt />
                  </span>
                  +91 94936 32575
                </p>
                <p>
                  <span>
                    <IoMdMail />
                  </span>
                  support@oraddo.com
                </p>
              </div>
              <div className="footer_li_items_right"></div>
            </div>
          </div>
        </div>
        <div className="footer_bottom">
          <div className="footer_bottom_copy">
            <div className="footerPTR">
              <p className="footer-itemAft" onClick={() => navigate("/PrivacyPolicy")}>Privacy Policy </p>
              <p className="footer-itemAft" onClick={() => navigate("/TermsAndConditions")}>Term & Conditions</p>
              <p className="footer-itemAft" onClick={() => navigate("/RefundPolicy")}>Refund Policy</p>
            </div>
            <span>
              ------------------------------------------------------------------------
            </span>
            <p>© Copyrights by Oraddo | TriDizi Digital Innovations</p>
          </div>
          <div className="footer_social_icons">
            <div className="footer_social_icons">
              <a
                href="https://www.facebook.com/profile.php?id=61569814444223"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaFacebook className="social_icon" />
              </a>
              <a
                href="https://www.instagram.com/ora.ddo/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaSquareInstagram className="social_icon" />
              </a>
              <a
                href="https://www.linkedin.com/company/oraddo/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedin className="social_icon" />
              </a>
              {/* <a href="https://www.youtube.com/" target="_blank" rel="noopener noreferrer">
    <FaYoutube className="social_icon" />
  </a> */}
            </div>
          </div>
        </div>
        <div className="whatsapp_div" onClick={handleWhatsappNavigate}>
          <img src={whtsImg} alt="whtsImg" />
        </div>
      </div>
    </>
  );
};

export default Footer;
